import { HTTP_URL } from "../config.js";

const TOKEN_KEY = "ember.token";

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

async function post<T>(path: string, body: unknown, auth = false): Promise<T> {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (auth) {
    const t = getToken();
    if (t) headers["Authorization"] = `Bearer ${t}`;
  }
  const res = await fetch(`${HTTP_URL}/api${path}`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as { error?: string }).error ?? "Request failed.");
  return data as T;
}

async function get<T>(path: string): Promise<T> {
  const headers: Record<string, string> = {};
  const t = getToken();
  if (t) headers["Authorization"] = `Bearer ${t}`;
  const res = await fetch(`${HTTP_URL}/api${path}`, { headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as { error?: string }).error ?? "Request failed.");
  return data as T;
}

export interface CharacterSummary {
  id: string;
  name: string;
  look: string;
  dead: boolean;
  gatheringXp: number;
  craftingXp: number;
  combatXp: number;
}
export interface RegisterResult {
  token: string;
  hasCharacter: boolean;
}
export interface LoginResult {
  token: string;
  characters: CharacterSummary[];
}
export interface MeResult {
  username: string;
  characters: CharacterSummary[];
  maxCharacters: number;
}
export interface ForgotPasswordResult {
  ok: true;
  devToken?: string;
}

export const api = {
  register: (email: string, username: string, password: string) =>
    post<RegisterResult>("/register", { email, username, password }),
  login: (email: string, password: string) =>
    post<LoginResult>("/login", { email, password }),
  forgotPassword: (identifier: string) =>
    post<ForgotPasswordResult>("/forgot-password", { identifier }),
  resetPassword: (token: string, password: string) =>
    post<{ ok: true }>("/reset-password", { token, password }),
  me: () => get<MeResult>("/me"),
  createCharacter: (name: string, look: string) =>
    post<CharacterSummary>("/character", { name, look }, true),
  submitReport: (
    type: "BUG" | "CR",
    title: string,
    body: string,
    context?: Record<string, unknown>,
  ) => post<{ ok: true }>("/support/tickets", { type, title, body, context }, true),
};
